import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { useEffect, useState } from "react";

export const RedirectExternal = ({ children, link }: { children: React.ReactNode, link: any }) => {
    const [isOpen, setIsOpen] = useState(false);
    const whiteList = [
        "youtube.com",
        "youtu.be",
        "teamly.one",
        "discord.com",
        "discord.gg",
        "github.com",
        "gitlab.com",
        "twitch.tv",
        "twitter.com",
        "facebook.com",
        "xbox.com",
        "x.com",
        "google.com",
        "microsoft.com",
        "apple.com",
        "amazon.com",
        "instagram.com",
        "reddit.com",
    ]

    const linkHost = new URL(link).hostname.replace('www.', '');

    useEffect(() => {
        if(!isOpen) return;
        if (whiteList.includes(linkHost)) {
            window.open(link, '_blank');
            setIsOpen(false);
        }
    }, [isOpen]);

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 rounded-lg shadow-lg p-6">
                <DialogHeader>
                    <DialogTitle className="text-xl font-semibold">
                        External Link Redirect
                    </DialogTitle>
                </DialogHeader>

                <div className="flex flex-col gap-6">
                    <Label className="text-gray-200">You are about to be redirected to an external site.</Label>
                    <input
                        readOnly
                        value={link}
                        className="w-full px-4 py-3 rounded-lg bg-brand-profile text-gray-300 border border-gray-700 focus:outline-none"
                        tabIndex={-1}
                    />
                    <Label className="text-gray-200">Click the button below to continue.</Label>
                    <Button
                        onClick={() => window.open(link, '_blank')}
                        className="bg-brand-green px-6 py-3 rounded-lg text-white font-semibold hover:bg-green-600"
                    >
                        Continue
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
